import { Section } from "@arp/react-ndbx";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import { Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import React from "react";
import { useOutletContext } from "react-router-dom";

export function ReviewAuraEdit({ nextAuraQuestion }) {
  const theme = useTheme();

  const {
    onBackButton: [onBackButton],
  } = useOutletContext();

  const editQuestion = (questionID) => {
    sessionStorage.setItem("editquestionid", questionID);
    onBackButton();
  };
  return (
    <Section
      sx={{
        textAlign: "right",
        // width: "fit-content !important",
      }}
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      onClick={() => {
        editQuestion(nextAuraQuestion.id);
      }}
    >
      <ModeEditOutlineRoundedIcon
        style={{
          color: `${theme.palette.action.PrimaryAction600}`,
          fontSize: "18px",
          cursor: "pointer",
        }}
      ></ModeEditOutlineRoundedIcon>
      <Typography
        variant="p2"
        sx={{
          color: `${theme.palette.action.PrimaryAction600}`,
          cursor: "pointer",
        }}
        ml={{
          xs: 1,
        }}
      >
        Edit
      </Typography>
    </Section>
  );
}
